export default __webpack_public_path__ + "static/funeral-37c812d2c9e701f9077e93d1342be49c.png";